import { TeamsUserCredential } from '@microsoft/teamsfx';
import { createContext } from 'react';
import { Theme } from '@fluentui/react-components';

import useTeamsFx from 'src/hooks/useTeamsFx';

interface TeamsFxContextInterface {
  theme?: Theme
  themeString: string
  teamsUserCredential?: TeamsUserCredential
}

export const TeamsFxContext = createContext<TeamsFxContextInterface>({
  theme: undefined,
  themeString: '',
  teamsUserCredential: undefined,
});

interface TeamsFxProviderOptions {
  children?: React.ReactNode
}

export const TeamsFxProvider: React.FC<TeamsFxProviderOptions> = ({ children }) => {
  const { theme, themeString, teamsUserCredential } = useTeamsFx();

  return (
    <TeamsFxContext.Provider value={{ theme, themeString, teamsUserCredential }}>
      {children}
    </TeamsFxContext.Provider>
  );
};

export default TeamsFxProvider;
